import { render, staticRenderFns } from "./profile-photo-drawer.vue?vue&type=template&id=2787f94a"
import script from "./profile-photo-drawer.vue?vue&type=script&lang=js"
export * from "./profile-photo-drawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2787f94a')) {
      api.createRecord('2787f94a', component.options)
    } else {
      api.reload('2787f94a', component.options)
    }
    module.hot.accept("./profile-photo-drawer.vue?vue&type=template&id=2787f94a", function () {
      api.rerender('2787f94a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/profile-photo-drawer.vue"
export default component.exports